import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for checking Stripe connected account status
export const checkConnectedAccountStatus = createAsyncThunk('connectedAccountStatus/checkConnectedAccountStatus', async (connectedAccountId) => {
  const response = await fetch(`/api/grantees/check-connected-account-status/${connectedAccountId}`);
  const data = await response.json();
  return data;
});

const checkConnectedAccountStatusSlice = createSlice({
  name: 'connectedAccountStatus',
  initialState: { connectedAccountStatus: null, status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkConnectedAccountStatus.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(checkConnectedAccountStatus.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.connectedAccountStatus = action.payload;
      })
      .addCase(checkConnectedAccountStatus.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default checkConnectedAccountStatusSlice.reducer;